import './request.constants-deb285e0.js';

const SITE = 'SITE';
const BUSINESS = 'BUSINESS';
const CATEGORY = 'CATEGORY';
const SUBCATEGORY = 'SUBCATEGORY';
const RANGE = 'RANGE';
const PRODUCT = 'PRODUCT';

const getProductInfoFromBreadcrumbs = (breadcrumbs) => {
  let productCategory = '';
  let productSubCategory = '';
  let productRange = '';
  let productName = '';
  const getProductName = (breadcrumb) => {
    switch (breadcrumb.itemType) {
      case RANGE:
      case PRODUCT:
        return breadcrumb.nameForChat;
      default:
        return breadcrumb.name;
    }
  };
  breadcrumbs.forEach((breadcrumb) => {
    switch (breadcrumb.itemType) {
      case CATEGORY:
        productCategory = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case SUBCATEGORY:
        productSubCategory = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case RANGE:
        productRange = breadcrumb.id;
        productName = getProductName(breadcrumb);
        break;
      case PRODUCT:
        productName = getProductName(breadcrumb);
        break;
    }
  });
  return {
    productCategory,
    productSubCategory,
    productRange,
    productName,
  };
};
const getFilteredBreadcrumbs = (breadcrumbs, breadcrumbItemTypes = [SITE, BUSINESS]) => breadcrumbs.filter((breadcrumb) => {
  return !breadcrumbItemTypes.includes(breadcrumb.itemType);
});

export { getProductInfoFromBreadcrumbs as a, getFilteredBreadcrumbs as g };
